import { FlashcardSortingEnum } from "@knowt/syncing/graphql/schema";
import { themeColors } from "./themeColors";

export const getSortingPillProps = (sort?: FlashcardSortingEnum) => {
    if (!sort) {
        return {
            label: undefined,
            backgroundColor: undefined,
            backgroundHoverColor: undefined,
            color: undefined,
        };
    }

    return {
        label: getLabel(sort),
        backgroundColor: getBackgroundColor(sort),
        backgroundHoverColor: getBackgroundHoverColor(sort),
        color: getColor(sort),
    };
};

export const getLabel = (sort: FlashcardSortingEnum) => {
    switch (sort) {
        case FlashcardSortingEnum.D_KNOW:
            return "Don't Know";
        case FlashcardSortingEnum.KNOW:
            return "Know";
    }
};

export const getColor = (sort: FlashcardSortingEnum) => {
    switch (sort) {
        case FlashcardSortingEnum.D_KNOW:
            return themeColors.errorPrimary;
        case FlashcardSortingEnum.KNOW:
            return themeColors.mcStudyDark4;
    }
};

export const getBackgroundColor = (sort: FlashcardSortingEnum) => {
    switch (sort) {
        case FlashcardSortingEnum.D_KNOW:
            return themeColors.errorSecondary;
        case FlashcardSortingEnum.KNOW:
            return themeColors.mcStudyLight4;
    }
};

export const getBackgroundHoverColor = (sort: FlashcardSortingEnum) => {
    switch (sort) {
        case FlashcardSortingEnum.D_KNOW:
            return themeColors.mcStudyMed1;
        case FlashcardSortingEnum.KNOW:
            return themeColors.mcStudyMed4;
    }
};
